import { useContext, useMemo } from "react";
import { PersonBankAccountViewModel } from "../../../generated/data-contracts";
import { IAxiosError, TableUtils } from "../../../utils";
import { AvisLoader } from "../../shared/components";
import { AvisDescriptiveText, AvisSection } from "../../shared/components/form";
import { AvisSimpleTable, IColumnConfig } from "../../shared/components/table";
import { AvisContext } from "../../shared/context/AvisContext";
import { ErrorLoadingDataHoc } from "../../shared/error/ErrorLoadingDataHoc";

interface IBillingDataGridProps {
  initGridData?: PersonBankAccountViewModel[];
  isGridLoading: boolean;
  error?: IAxiosError;
}

export function BillingDataGrid(props: Readonly<IBillingDataGridProps>) {
  const { initGridData, isGridLoading, error } = props;
  const { res } = useContext(AvisContext);

  const columnMetadata: IColumnConfig[] = useMemo(() => {
    return [
      TableUtils.columnConfigString<PersonBankAccountViewModel>(
        "bankName",
        res("authors_BillingDataPage_BankTableColumn_BankName"),
      ),
      TableUtils.columnConfigString<PersonBankAccountViewModel>(
        "accountNumber",
        res("authors_BillingDataPage_BankTableColumn_AccountNumber"),
        undefined,
        215,
      ),
      TableUtils.columnConfigDateTime<PersonBankAccountViewModel>(
        "dateFrom",
        res("authors_BillingDataPage_BankTableColumn_DateFrom"),
        undefined,
        115,
      ),
      TableUtils.columnConfigBoolean<PersonBankAccountViewModel>(
        "royalties",
        res("authors_BillingDataPage_BankTableColumn_Royalties"),
        res,
      ),
    ];
  }, [res]);

  const renderGrid = () => {
    if (!initGridData) return <AvisLoader inline />;

    return (
      <ErrorLoadingDataHoc error={error} loading={isGridLoading}>
        <AvisSimpleTable<PersonBankAccountViewModel>
          columnMetadata={columnMetadata}
          data={initGridData}
        />
      </ErrorLoadingDataHoc>
    );
  };
  return (
    <AvisSection title={res("authors_BillingDataPage_Section_BanksTitle")}>
      <AvisDescriptiveText textKey="portal_RH_BillingData_3" />
      {renderGrid()}
    </AvisSection>
  );
}
